import React, { useState, useEffect } from "react";
import { addJob, deleteJob, updateJobHomeVisibility } from "../../api/api";
import { useGlobalData } from "../../context/GlobalDataContext";
import "./AdminPanel.css";

function JobAdminPanel() {
  const [formData, setFormData] = useState({ title: "", slug: "" });
  const { threeTable = {}, loading, fetchThreeTable } = useGlobalData();
  const jobs = threeTable.jobs || [];
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("darkMode") === "true"
  );
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (!threeTable?.jobs?.length) {
      fetchThreeTable();
    }
  }, [threeTable?.jobs?.length, fetchThreeTable]);

  useEffect(() => {
    const syncDarkMode = () =>
      setDarkMode(localStorage.getItem("darkMode") === "true");
    window.addEventListener("storage", syncDarkMode);
    window.addEventListener("darkModeChanged", syncDarkMode);
    return () => {
      window.removeEventListener("storage", syncDarkMode);
      window.removeEventListener("darkModeChanged", syncDarkMode);
    };
  }, []);

  if (role !== "superadmin") {
    return (
      <div style={{ color: "red", textAlign: "center", marginTop: "2rem" }}>
        Access denied: Superadmin only
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim() || !formData.slug.trim()) {
      alert("Please enter both job title and job slug.");
      return;
    }

    try {
      await addJob({
        title: formData.title.trim(),
        slug: formData.slug.trim()
      });
      alert("Job added!");
      setFormData({ title: "", slug: "" });
      await fetchThreeTable();
    } catch (error) {
      alert(error?.response?.data?.error || "Failed to add job.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this job?")) return;

    try {
      await deleteJob(id);
      alert("Job deleted!");
      await fetchThreeTable();
    } catch (error) {
      alert(error?.response?.data?.error || "Failed to delete job.");
    }
  };

  const handleToggleHomeVisibility = async (job) => {
    try {
      await updateJobHomeVisibility(job._id, job.showOnHome === false);
      await fetchThreeTable();
    } catch (error) {
      alert(error?.response?.data?.error || "Failed to update visibility.");
    }
  };

  return (
    <div
      className={`resource-admin-panel resource-admin-panel--emerald${
        darkMode ? " dark-mode" : ""
      }`}
    >
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">💼 Job Admin Panel</h2>
          <p className="resource-admin-panel__subtext">
            Yahan se job entries manage karo. Job add karo, list me dekho, home
            par visibility toggle karo ya delete karo.
          </p>
        </div>
        <div className="resource-admin-panel__pill">Jobs</div>
      </div>

      <form className="resource-admin-panel__form" onSubmit={handleSubmit}>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Job Title</label>
          <input
            className="resource-admin-panel__input"
            placeholder="Job Title"
            value={formData.title}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, title: e.target.value }))
            }
            required
          />
        </div>

        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Job Slug</label>
          <input
            className="resource-admin-panel__input"
            placeholder="Job Slug"
            value={formData.slug}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, slug: e.target.value }))
            }
            required
          />
        </div>

        <button className="resource-admin-panel__submit" type="submit">
          ✅ Add Job
        </button>
      </form>

      <div className="resource-admin-panel__section">
        <div className="resource-admin-panel__section-top">
          <div>
            <h3 className="resource-admin-panel__section-title">Saved Jobs</h3>
            <p className="resource-admin-panel__section-meta">{jobs.length} items</p>
          </div>
        </div>

        {loading ? (
          <p className="resource-admin-panel__empty">Loading...</p>
        ) : jobs.length === 0 ? (
          <p className="resource-admin-panel__empty">No jobs found</p>
        ) : (
          <div className="resource-admin-panel__list">
            {jobs.slice(0, 15).map((job) => (
              <div key={job._id} className="resource-admin-panel__item">
                <div>
                  <p className="resource-admin-panel__item-title">{job.title}</p>
                  <p className="resource-admin-panel__item-subtitle">
                    Slug: {job.slug}
                  </p>
                  <span
                    style={{
                      marginLeft: "8px",
                      color: job.showOnHome === false ? "#d32f2f" : "#2e7d32",
                      fontWeight: "bold"
                    }}
                  >
                    {job.showOnHome === false
                      ? "Hidden on Home"
                      : "Visible on Home"}
                  </span>
                </div>

                <div className="resource-admin-panel__actions job-admin-panel__actions-grid">
                  <div className="job-admin-panel__action-col">
                    <a
                      href={`/mform/${job.slug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="resource-admin-panel__link"
                    >
                      View Live
                    </a>
                  </div>

                  <div className="job-admin-panel__action-col">
                    <button
                      type="button"
                      className="resource-admin-panel__link"
                      style={{
                        background:
                          job.showOnHome === false ? "#2e7d32" : "#f57c00",
                        color: "white"
                      }}
                      onClick={() => handleToggleHomeVisibility(job)}
                    >
                      {job.showOnHome === false
                        ? "Show on Home"
                        : "Hide from Home"}
                    </button>
                  </div>

                  <div className="job-admin-panel__action-col">
                    <button
                      type="button"
                      className="resource-admin-panel__delete"
                      onClick={() => handleDelete(job._id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default JobAdminPanel;